import { getValueForKey } from './objectUtils'
import { readableCharityFieldMap } from './charity'
import { readableCampaignFieldMap } from './campaign'

export function generateCSV(jsonData: unknown[], selectedProperties: string[] = []) {
  if (!Array.isArray(jsonData) || jsonData.length === 0) {
    throw new Error('Invalid JSON data. Must be a non-empty array.')
  }

  const csvRows = jsonData.map((row: any) =>
    selectedProperties
      .map(fieldName => {
        let value = getValueForKey(row, fieldName)

        // Handle specific cases for charity status and note where note should be used instead of status
        if (fieldName === 'charity.status' && row.charity.note) {
          value = getValueForKey(row, 'charity.note')
        }

        if (typeof value === 'string') {
          value = `"${value.replace(/"/g, '""')}"`
        } else if (typeof value === 'object' && value !== null) {
          value = `"${JSON.stringify(value).replace(/"/g, '""')}"`
        } else if (value === null || value === undefined) {
          value = ''
        }

        return value
      })
      .join(',')
  )

  return [
    selectedProperties
      .map(prop =>
        getValueForKey(
          {
            charity: readableCharityFieldMap,
            campaign: readableCampaignFieldMap
          },
          prop
        )
      )
      .join(','),
    ...csvRows
  ].join('\r\n')
}

export function createCSVFileForDownload(csv: string) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  return URL.createObjectURL(blob)
}
